export default __webpack_public_path__ + "static/media/dashboard_white.042df99f.svg";